import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AngularFirestore } from '@angular/fire/firestore';
import { switchMap, map, filter } from 'rxjs/operators';

import * as AccountActions from '../account/account.actions';
import * as PatientActions from './patient.actions';
import { Patient } from 'src/app/core/models/patient.model';
import { of } from 'rxjs';
import { CabinetService } from 'src/app/core/services/cabinet.service';


@Injectable()
export class PatientEffects {

  loadCabinets$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.authenticated),
      switchMap(() => this.cabinetService.cabinet$),
      filter(cabinet => !!cabinet),
      switchMap(cabinet => {
        return this.afs.collection<Patient>('patients', ref => ref.where('cabinetId', '==', cabinet.cid)).snapshotChanges();
      }),
      switchMap(actions => {
        const addActions = actions.filter(action => action.type === 'added');
        const loadAction = PatientActions.addPatients({
          patients: addActions.map(action => {
            return {
              ...action.payload.doc.data(),
              id: action.payload.doc.id,
            };
          })
        });
        const otherActions = actions.filter(action => action.type !== 'added').map(action => {
          switch (action.type) {
            case 'modified':
              return PatientActions.updatePatient({
                patient: {
                  id: action.payload.doc.id,
                  changes: {
                    ...action.payload.doc.data()
                  }
                }
              });
            case 'removed':
              return PatientActions.deletePatient({
                id: action.payload.doc.id
              });
            default:
              break;
          }
        });
        const allActions = [
          loadAction,
          ...otherActions
        ];
        return of(...allActions);
      })
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.logout),
      map(() => PatientActions.clearPatients())
    );
  });



  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private cabinetService: CabinetService
  ) {}

}
